import type {
  AdminCharacterItem,
  AdminCharacterResponse,
  CharacterCreateRequest,
  CharacterCreateResponse,
} from "../../../types/api.generated";

export type CharacterItem = AdminCharacterItem;
export type CreatedCharacter = CharacterCreateResponse;

export type CharacterSortProperty = "name" | "createdAt";

export interface CharacterQueryParams {
  page?: number;
  limit?: number;
  sort?: CharacterSortProperty;
  order?: "ASC" | "DESC";
}

const getBaseUrl = () => process.env.REACT_APP_BACKEND_URL || "";
const getToken = () => sessionStorage.getItem("tokenUser");

export const getCharacters = async (params: CharacterQueryParams = {}): Promise<AdminCharacterResponse> => {
  const token = getToken();
  const base = getBaseUrl();
  const searchParams = new URLSearchParams();
  if (params.page) searchParams.set("page", String(params.page));
  if (params.limit) searchParams.set("limit", String(params.limit));
  if (params.sort) searchParams.set("sort", params.sort);
  if (params.order) searchParams.set("order", params.order);
  const query = searchParams.toString();
  const response = await fetch(
    `${base}/admin/characters${query ? `?${query}` : ""}`,
    {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}`},
    }
  );
  if (!response.ok) {
    const text = await response.text();
    throw new Error(`Failed to fetch characters: ${response.status} ${response.statusText} ${text}`);
  }
  return response.json();
};

export const createCharacter = async ({ name, avatar }: CharacterCreateRequest): Promise<CharacterCreateResponse> => {
  const form = new FormData();
  form.append("name", name.trim());
  form.append("avatar", avatar, avatar.name);

  const response = await fetch(`${getBaseUrl()}/admin/characters`, {
    method: "POST",
    headers: { Authorization: `Bearer ${getToken()}` },
    body: form,
  });

  if (!response.ok) {
    if (response.status === 409) throw new Error("A character with this name already exists.");
    if (response.status === 413) throw new Error("The avatar must be 5 MB or smaller.");
    if (response.status === 400) throw new Error("Check the character name and choose a valid JPEG, PNG, or WebP image.");
    throw new Error("Unable to create the character. Please try again.");
  }

  return response.json();
};
